import React from "react"
import { uniq } from "lodash"

const DIAL_CODES = uniq([
  "+48",
  "+7",
  ...st.DIAL_CODES.map(x => x[0]).sort(),
])

const DIAL_CODES_PER_LOCALE = {
  pl: "+48",
  ru: "+7",
  en: "+44",
}

const splitPhoneNumber = (value, defaultValue = {}) => {
  if (!value) {
    return {
      dialCode: defaultValue.dialCode || null,
      phoneNumber: defaultValue.phoneNumber || null,
    }
  }
  const dialCode = DIAL_CODES.concat().reverse().find(dc => value.indexOf(dc) === 0) || defaultValue.dialCode || null
  const phoneNumber = (dialCode ? value.replace(dialCode, "") : value) || defaultValue.phoneNumber || null
  return { dialCode, phoneNumber }
}

const joinPhoneNumber = ({ dialCode, phoneNumber }) => (
  ((dialCode || "") + (phoneNumber || "")) || null
)

export default class PhoneNumberFormControl extends React.PureComponent {
  constructor(...args) {
    super(...args)
    this.state = {
      splitValue: splitPhoneNumber(this.props.value, { dialCode: DIAL_CODES_PER_LOCALE[I18n.locale] })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      (nextProps.value && !this.state.splitValue.phoneNumber)
      || (!nextProps.value && this.state.splitValue.phoneNumber)
      || (joinPhoneNumber(this.state.splitValue) != nextProps.value)
    ) {
      this.setState({
        splitValue: splitPhoneNumber(nextProps.value)
      })
    }
  }

  handleChange({ dialCode, phoneNumber }) {
    this.setState({ splitValue: { dialCode, phoneNumber } })
    this.props.onChange(joinPhoneNumber({ dialCode, phoneNumber }))
  }

  render() {
    const {
      id,
      name,
      value,
      onChange,
    } = this.props
    const { splitValue: { dialCode, phoneNumber } } = this.state

    return (
      <span className="c-PhoneNumberFormControl">
        <select
          id={id}
          name={name}
          className="form-control form-control-inline c-PhoneNumberFormControl-dialCode"
          value={dialCode || ""}
          onChange={event => this.handleChange({ dialCode: event.target.value, phoneNumber })}
        >
          {DIAL_CODES.map(d =>
            <option key={d} value={d}>{d}</option>
          )}
        </select>
        <br  className="visible-xs visible-sm" />
        <input
          className="form-control form-control-inline c-PhoneNumberFormControl-phoneNumber"
          type="tel"
          value={phoneNumber || ""}
          onChange={event => this.handleChange({ phoneNumber: event.target.value, dialCode })}
          />
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./app/webpack/frontend/components/PhoneNumberFormControl.jsx